/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ language: NonNullable<unknown> }} Remove_LanguageInputs */

const en_remove_language = /** @type {(inputs: Remove_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.language}`)
};

const fr_remove_language = /** @type {(inputs: Remove_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Supprimer ${i?.language}`)
};

const de_remove_language = /** @type {(inputs: Remove_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entferne ${i?.language}`)
};

const it_remove_language = /** @type {(inputs: Remove_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rimuovi ${i?.language}`)
};

const ru_remove_language = /** @type {(inputs: Remove_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Удалить ${i?.language}`)
};

const es_remove_language = /** @type {(inputs: Remove_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eliminar ${i?.language}`)
};

const zh_cn2_remove_language = /** @type {(inputs: Remove_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`移除${i?.language}`)
};

const ja_remove_language = /** @type {(inputs: Remove_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.language} を削除`)
};

const hi_remove_language = /** @type {(inputs: Remove_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.language} को हटाएँ`)
};

const pt_pt2_remove_language = /** @type {(inputs: Remove_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remover ${i?.language}`)
};

/**
* | output |
* | --- |
* | "Remove {language}" |
*
* @param {Remove_LanguageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_language = /** @type {((inputs: Remove_LanguageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_LanguageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remove_language(inputs)
	if (locale === "de") return de_remove_language(inputs)
	if (locale === "it") return it_remove_language(inputs)
	if (locale === "ru") return ru_remove_language(inputs)
	if (locale === "es") return es_remove_language(inputs)
	if (locale === "zh-CN") return zh_cn2_remove_language(inputs)
	if (locale === "ja") return ja_remove_language(inputs)
	if (locale === "hi") return hi_remove_language(inputs)
	if (locale === "pt-PT") return pt_pt2_remove_language(inputs)
	return en_remove_language(inputs)
});